<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">基本設定</div>
        </div>
        <!--車位設定-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">車位設定</div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">風景區</th>
                      <th scope="col" width="35%">現行車位</th>
                      <th scope="col" width="35%">修改車位</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in scenicAreaList" :key="key">
                      <td :class="tableCenterStyle">{{ key + 1 }}</td>
                      <td :class="tableCenterStyle">{{ item.name }}</td>
                      <td :class="tableCenterStyle">
                        {{
                          `大型車: ${item.fullSizeCarNumber} | 小型車: ${item.compactCarNumber} | 機車: ${item.motorcycleNumber}`
                        }}
                      </td>
                      <td :class="tableCenterStyle">
                        <button
                          class="btn btn-info"
                          @click="editParkingSpace(item)"
                        >
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!--人數推估設定-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              人車流統計_人數推估設定
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">類型</th>
                      <th scope="col" width="35%">目前設定平均載客人數</th>
                      <th scope="col" width="35%">修改設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in externalEstimateList"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>{{ CONST.ESTIMATE_DAT_TYPE[item.dayType] }}</td>
                      <td>{{ CONST.ESTIMATE_CAR_TYPE[item.passengerType] + ' : ' + item.averageNumber}}</td>
                      <td>
                        <button
                          class="btn btn-info"
                          @click="editEstimate(item)"
                        >
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!--人數推估設定(內部參考)-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              人車流統計(內部參考)_人數推估設定
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">類型</th>
                      <th scope="col" width="35%">目前設定平均載客人數</th>
                      <th scope="col" width="35%">修改設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in internalEstimateList.filter(e => e.passengerType !== 'suv')"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>{{ CONST.ESTIMATE_DAT_TYPE[item.dayType] }}</td>
                      <td>{{ CONST.ESTIMATE_CAR_TYPE[item.passengerType] + ' : ' + item.averageNumber}}</td>
                      <td>
                        <button
                          class="btn btn-info"
                          @click="editEstimate(item)"
                        >
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->

    <dialog-modal
      ref="ParkingSapceEditor"
      :showUpdateButton="true"
      customUpdateButton="修改"
      :modalSize="''"
      :isImage="false"
      :isMarginAuto="false"
      @update-button-click="updateParkingSpace"
    >
      <div class="pb-1" v-if="selectScenicArea != null"> <!--using v-if for avoid to selectScenicArea is not defined -->   
        <div class="form-group h6">
          <label for="exampleInputEmail1">大型車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectScenicArea.fullSizeCarNumber"
          />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">小型車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectScenicArea.compactCarNumber"
          />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">機車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectScenicArea.motorcycleNumber"
          />
        </div>
      </div>
    </dialog-modal>

    <dialog-modal
      ref="estimateEditor"
      :showUpdateButton="true"
      customUpdateButton="修改"
      :modalSize="''"
      :isImage="false"
      :isMarginAuto="false"
      @update-button-click="updateEstimate"
    >
      <div class="pb-1" v-if="selectEstimate != null"> <!--using v-if for avoid to selectScenicArea is not defined -->   
        <div class="form-group h6">
          <label for="exampleInputEmail1">{{CONST.ESTIMATE_CAR_TYPE[selectEstimate.passengerType]}}</label>
          <input
            type="number"
            class="form-control"
            min="0"
            step='0.1'
            v-model.number="selectEstimate.averageNumber"
          />
        </div>
      </div>
    </dialog-modal>
    <!-- Modal -->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";

export default {
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectScenicArea: null,
      internalEstimateList: [],
      externalEstimateList: [],
      selectEstimate: null,
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),
  },
  watch: {
    estimateDataList () {
      for(let i = 0 ; i < this.estimateDataList.length ; i++) {

        if(this.estimateDataList[i].isInternal === 'true') {
          this.internalEstimateList = this.estimateDataList[i][CONST.ESTIMATE_KEY]
        } else {
          this.externalEstimateList = this.estimateDataList[i][CONST.ESTIMATE_KEY]
        }
      }
    }
  },
  methods: {
    editParkingSpace(item) {
      this.$refs.ParkingSapceEditor.openModal()
      this.selectScenicArea = item
    },

    async updateParkingSpace() {
      const result = await this.$store.dispatch('scenicArea/putScenicArea', this.selectScenicArea)

      if(result.success) {
        this.$refs.ParkingSapceEditor.closeModal();
      } else {
        alert('修改失敗')
      }
    },

    editEstimate(item) {
      this.$refs.estimateEditor.openModal()
      this.selectEstimate = item
    },

    async updateEstimate() {
      const result = await this.$store.dispatch('passengerEstimateSetting/putEstimate', this.selectEstimate)

      if(result.success) {
        this.$refs.estimateEditor.closeModal();
        this.$store.dispatch('passengerEstimateSetting/getEstimate')
      } else {
        alert('修改失敗')
      }
    }
  },
  mounted() {
    this.$store.dispatch('passengerEstimateSetting/getEstimate')
  },
  components: { DialogModal },
};
</script>
